<div class="modificacion" *ngFor="let opcio of opciones ">
  <div class="roundedOne ">
    <input [id]="opcio.idcss" type="checkbox" [checked]="opcio.activo" (change)="onchange(opcio);" />
    <label [for]="opcio.idcss"></label>
  </div>
  <div (click)="onchange(opcio);" class="labelreal">
    {{opcio.nombre}}
  </div>
</div>
